import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=6fb99bc7&scoped=true"
var script = {}
import style0 from "./Team.vue?vue&type=style&index=0&id=6fb99bc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb99bc7",
  null
  
)

export default component.exports